import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom"; 
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = () => {
    const [open, setOpen] = useState(true);
    const toggleDrawer = () => setOpen(!open);

    const [selection, setSelection] = useState({ calculation: "", model: "" });

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CssBaseline />
            <Header open={open} onSelectionChange={setSelection} />
            <Box sx={{ display: "flex", flexGrow: 1 }}>
                <Sidebar open={open} toggleDrawer={toggleDrawer} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        transition: "margin 0.3s ease-in-out",
                    }}
                >
                    {/* Pass selection + setSelection to Outlet via context */}
                    <Outlet context={{ selection, setSelection }} />
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;